export default __webpack_public_path__ + "static/media/head-mint.859f808a.png";